import { UI_CLIENTS, CONFIG_TYPE } from 'src/constants/GlobalConstants';
import { configStore } from './AppConfig';

/**
 * Function responsible to fetch the config from a config store.
 * @param accountName name of the account.
 * @param websiteType website type, VICI or RegulatorCentral
 * @param configType CONFIG_TYPE
 * @returns config in the configStore.
 */
export function fetchFromAppConfig(
  accountName: string,
  websiteType: UI_CLIENTS,
  configType: CONFIG_TYPE,
  propertyAttribute?: string,
) {
  const config = propertyAttribute
    ? configStore[accountName]?.[websiteType]?.[configType]?.[propertyAttribute]
    : configStore[accountName]?.[websiteType]?.[configType];

  if (config) {
    return config;
  }
  return propertyAttribute
    ? configStore.DEFAULT?.[websiteType]?.[configType]?.[propertyAttribute]
    : configStore.DEFAULT?.[websiteType]?.[configType];
}
